module.exports = __webpack_public_path__ + "img/86076440.ea520116.png";